// Agregaciones compartidas entre Panel general, Ingresos y egresos, y Alertas.

/** Devuelve los últimos `count` períodos {year, month} terminando en el actual. */
export function lastMonths(count, from = new Date()) {
  const months = [];
  const cursor = new Date(from.getFullYear(), from.getMonth(), 1);
  for (let i = count - 1; i >= 0; i--) {
    const d = new Date(cursor.getFullYear(), cursor.getMonth() - i, 1);
    months.push({ year: d.getFullYear(), month: d.getMonth() + 1 });
  }
  return months;
}

function monthKey(year, month) {
  return `${year}-${String(month).padStart(2, "0")}`;
}

/**
 * Suma ingresos/egresos por mes a partir de la tabla movements.
 * Devuelve un array alineado con `lastMonths(count)`.
 */
export function monthlyMovementTotals(movements, count = 8, from = new Date()) {
  const months = lastMonths(count, from);
  const totals = new Map(months.map((m) => [monthKey(m.year, m.month), { ingreso: 0, egreso: 0 }]));

  for (const mv of movements) {
    const d = new Date(mv.date + "T00:00:00");
    const key = monthKey(d.getFullYear(), d.getMonth() + 1);
    if (!totals.has(key)) continue;
    const bucket = totals.get(key);
    if (mv.type === "ingreso") bucket.ingreso += Number(mv.amount) || 0;
    else bucket.egreso += Number(mv.amount) || 0;
  }

  return months.map((m) => ({ ...m, key: monthKey(m.year, m.month), ...totals.get(monthKey(m.year, m.month)) }));
}

/** Filtra eventos cuya fecha cae dentro de los últimos `count` meses (incluye el actual). */
export function eventsInLastMonths(events, count, from = new Date()) {
  const months = new Set(lastMonths(count, from).map((m) => monthKey(m.year, m.month)));
  return events.filter((e) => {
    const d = new Date(e.date + "T00:00:00");
    return months.has(monthKey(d.getFullYear(), d.getMonth() + 1));
  });
}

export function sum(arr, fn) {
  return arr.reduce((acc, item) => acc + (Number(fn(item)) || 0), 0);
}

export function daysSince(dateStr, from = new Date()) {
  const d = new Date(dateStr + "T00:00:00");
  return Math.floor((from.getTime() - d.getTime()) / (1000 * 60 * 60 * 24));
}
